export const getProfile = (state) => state.commonNetReducer.profile
